<template>
  <loader v-if="reports === null" />

  <div v-else>
    <h1 class="mb-1 text-2xl">{{ selectedOffice.name }}</h1>
    <p class="mb-6 leading-normal">You are viewing the managed service fee submissions for the {{ selectedOffice.name }}. You can view the submissions for another office by clicking <i class="fas fa-cog"></i> in the top right, followed by "Change Office".</p>

    <panel v-if="reports.data.length === 0" class="mt-5 pt-6">
      <strong class="mb-2">No Reports</strong>
      <p>There are no available reports.</p>
    </panel>

    <panel class="mb-6 pt-6" v-else>
      <div class="w-full max-w-full overflow-x-auto overflow-y-hidden">
        <table class="table-auto text-center w-full">
          <thead class="uppercase text-xs">
            <tr>
              <th class="text-left p-2 whitespace-no-wrap w-10">
                ID
              </th>
              <th class="text-left p-2 whitespace-no-wrap">
                Report
              </th>
              <th class="text-left p-2 whitespace-no-wrap">
                Status
              </th>
              <th class="text-left p-2 whitespace-no-wrap">

              </th>
            </tr>
          </thead>
          <tbody class="text-sm">
            <tr v-for="report in reports.data" :key="report.id" @click="$emit('change', report.id)" class="hover:bg-grey-lighter rounded cursor-pointer border-b">
              <td class="text-left p-3">
                {{ report.id }}
              </td>
              <td class="text-left p-3">
                {{ report.month | month }} {{ report.year }}
              </td>
              <td class="text-left p-3">
                {{ statuses[report.status_id] }}
              </td>
              <td class="text-right p-3">
                <i class="fas fa-arrow-right"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <paginator :data="reports" @change="pageChanged"/>
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { v2Api } from '@/http'
import Loader from '../../components/Loader.vue'
export default {
  components: { Loader },
  data () {
    return {
      searchParams: {
        page: 1
      },
      statuses: ['Not Started', 'In Progress', 'Completed', 'Approved'],
      reports: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.getReports()
  },
  methods: {
    getReports () {
      v2Api.get('tpfg-monthly-reports', {
        params: {
          ...this.searchParams,
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.reports = response.data
      })
    },
    pageChanged (page) {
      this.searchParams.page = page
    }
  },
  watch: {
    selectedOffice () {
      this.reports = null
      this.searchParams.page = 1
      this.getReports()
    }
  }
}
</script>
